var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"mb__iphone-x-left mb__iphone-x-right mb__iphone-x-bottom",attrs:{"status":"注文"}},[_c('HOOrderListTab'),_c('HOOrderList',{attrs:{"served":_vm.servedOrder}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }